import React, { createContext, useContext, ReactNode } from 'react';

interface ApiContextType {
  apiEndpoint: string;
}

const ApiContext = createContext<ApiContextType>({
  apiEndpoint: 'http://localhost:3000/api',
});

export const useApi = () => useContext(ApiContext);

interface ApiProviderProps {
  children: ReactNode;
  endpoint?: string;
}

export function ApiProvider({ children, endpoint = 'http://localhost:3000/api' }: ApiProviderProps) {
  return (
    <ApiContext.Provider value={{ apiEndpoint: endpoint }}>
      {children}
    </ApiContext.Provider>
  );
}
